;(function() {
  'use strict'

  angular.module('core.filters').filter('dayDate', Filter)

  /* @ngInject */
  function Filter() {
    return function(date) {
      return date ? moment(date).format('D MMM YYYY') : ''
    }
  }
})()
